import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowBottomRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"square-arrow-bottom-right, resize small, box, arrow"} maskId="square-filled-radius-0-stroke-1-IconSquareArrowBottomRight"><path fillRule="evenodd" clipRule="evenodd" d="M3 3L21 3V10H20V4L4 4L4 20H10V21H3L3 3ZM11.5 10.7929L20 19.2929V14H21V21H14V20H19.2929L10.7929 11.5L11.5 10.7929Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSquareArrowBottomRight;
